import { createAction, createSlice } from '@reduxjs/toolkit';

import { initialStore } from '../initial-store';

export const getTraders = createAction('users/GET_TRADERS');

const tradersSlice = createSlice({
  initialState: initialStore.tradersPage,
  name: 'tradersPage',
  reducers: {
    removeTrader: (state, { payload }) => {
      state.data = state.data.filter((item) => item.id !== payload.id);
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setTraders: (state, { payload }) => {
      const { count, result } = payload;
      state.data = result;
      state.count = count;
      state.isLoading = false;
    },
    updateTrader: (state, { payload }) => {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    }
  }
});

export const { removeTrader, setLoading, setTraders, updateTrader } =
  tradersSlice.actions;

export const { reducer } = tradersSlice;
